
<template>
    <div class="post" id="viewport-for-capture" :style="{ width: resolution + 'px' }">
        <Phone :showNotch="true">
            <renderPostManager
                v-if="formData && pageIdSelected && pages[pageIdSelected]"
                :typeNetworkSelected="pages[pageIdSelected].network"
                :formData="formData"
                :files="files"
                :pages="[pages[pageIdSelected]]"
            />
        </Phone>
       
    </div>
</template>


<script>

    import RenderPostManager from '@/components/dash/postCreator/components/standardTab/RenderPostManager.vue'
    import Phone from "@/components/dash/postCreator/components/Phone.vue"

    import { 
        mergeUpdates, 
    } from '@/components/dash/postCreator/utils.js'

    export default {
        components: {
            RenderPostManager,
            Phone
        },
        props: {
            pageIdSelected: String,
        },
        data() {
            return {
                draft: null,
                formData : null,
                pages: {},
                files: {},
                resolution: 1080
            }
        },
    
        created () {
           if (localStorage.postPreviewData) {
             
                const postPreviewData = JSON.parse(localStorage.postPreviewData)

                this.files = postPreviewData.draft.files
                this.draft = postPreviewData.draft
                this.pages = postPreviewData.pages || {}
                this.resolution= postPreviewData.resolution || 1080
                this.generateFormData()
            }
           
        },
        mounted () {
           [ "1ac1bbd8-b788-4ab5-8629-fc65ae070290", "93134837-e711-4fd5-bb99-403c90975519", "06755579-edb3-4f50-abe7-0303ecd1d4a5" ]
        },
        methods: {
            generateFormData() {
                if (!this.pageIdSelected || !this.pages[this.pageIdSelected]) {
                    const pagesId = Object.keys(this.pages)
                    if (pagesId.length) this.pageIdSelected = pagesId[0]
                }
    
                if (this.pageIdSelected && this.pages[this.pageIdSelected] && this.draft.saveAllFormData) {
           
                    const page = this.pages[this.pageIdSelected]
                
                    const formDataRef = JSON.parse(JSON.stringify(this.draft.saveAllFormData.main))
                    if (this.draft.saveAllFormData.networks[page.network]) mergeUpdates(formDataRef, this.draft.saveAllFormData.networks[page.network])
                    if (this.draft.saveAllFormData.pages[page.id]) mergeUpdates(formDataRef, this.draft.saveAllFormData.pages[page.id])
                    this.formData = formDataRef
                }
            },

            waitForImageToLoad(img) {
                return new Promise((resolve, reject) => {
                    if (img.complete && img.naturalHeight !== 0 && img.naturalWidth !== 0) {
                        setTimeout(() => {resolve()}, 0);
                    } else {
                        // Attends que l'image déclenche l'événement "load"                                      
                        img.onload = () => {
                            requestAnimationFrame(() => {
                                resolve();
                            });
                        };
                        img.onerror = () => reject(new Error("Échec du chargement de l'image"));
                    }
                });
            },

            waitForVideoToLoad(video) {
                return new Promise((resolve, reject) => {
                    if (video.readyState >= 3) { // readyState 3 (HAVE_FUTURE_DATA) signifie que la vidéo est prête à être lue
                        resolve();
                    } else {
                        video.onloadeddata = () => {
                            requestAnimationFrame(() => {
                                resolve();
                            });
                        }
                        video.onerror = () => reject(new Error("Échec du chargement de la vidéo"));
                    }
                });
            }
        },
        watch: {
            pageIdSelected: {
                immediate: false,
                handler(newValue, oldValue) {
                    this.generateFormData()
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>